import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";


export function useMaintenanceCalendarApi() {
  const callApi = useApiCall();

  const getFrequencyList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_FREQUENCY_LIST, data, onSuccess, onError);
  };

  const getSchedulerCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_CODE, data, onSuccess, onError);
  };
  
  const getSchedulerType = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_TYPE, data, onSuccess, onError);
  };
  
  const saveScheduler = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.SAVE_SCHEDULER, data, onSuccess, onError);
  };

  const getSchedulerList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_LIST, data, onSuccess, onError);
  };

  const getSchedulerByID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_BY_ID, data, onSuccess, onError);
  };

  const deleteScheduler = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.DELETE_SCHEDULER, data, onSuccess, onError);
  };

  const uploadImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.UPLOAD_IMAGE, data, onSuccess, onError);
  };

  const uploadAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.UPLOAD_ATTACHMENT, data, onSuccess, onError);
  };

  const getSchedulerAttachments = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_ATTACHMENTS, data, onSuccess, onError);
  };

  const getSchedulerImages = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_IMAGES, data, onSuccess, onError);
  };

  const deleteSchedulerFiles = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_IMAGES, data, onSuccess, onError);
  };

  const exportToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.EXPORT_TO_PDF, data, onSuccess, onError);
  };

  const exportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.MAINTENANCE_CALENDER.EXPORT_TO_XLS, data, onSuccess, onError);
  };


  return {
    getFrequencyList,
    getSchedulerCode,
    getSchedulerType,
    saveScheduler,
    getSchedulerList,
    getSchedulerByID,
    deleteScheduler,
    uploadImage,
    uploadAttachment,
    getSchedulerAttachments,
    getSchedulerImages,
    deleteSchedulerFiles,
    exportToPDF,
    exportToXLS
  };
}
